
export class RemoveProductsRequest {
  planogramId: string = '';
  stateId: string = '';
  barcodes: string[] = [];

  constructor(planogramId: string, stateId: string, barcodes: string[]) {
    this.planogramId = planogramId;
    this.stateId = stateId;
    this.barcodes = barcodes;
  }
}
